import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ForoBanner } from "../../components/Foro/ForoBanner";
import { Footer } from "../../components/Footer";
import ForoPage from "./index";
import CategoryView from "./CategoryView";
import DiscussionView from "./DiscussionView";

export const ForoLayout = () => {
  const location = useLocation();

  return (
    <div className="font-montserrat">
      <ForoBanner />
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          style={{ width: "100%" }}
        >
          <Routes location={location}>
            <Route index element={<ForoPage />} />
            <Route path="/" element={<ForoPage />} />
            <Route path="discussion/:discussionId" element={<DiscussionView />} />
            <Route path=":categoryId" element={<CategoryView />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
      <Footer />
    </div>
  );
};

export default ForoLayout;
